// src/globalFunctions.js

export default {
  isNullOrEmpty(val) {
    return val === null || val === undefined || val === '';
  },

  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  },

  // You can add more functions here later
};
